<template>
	<span
  class="single-tag"
  :class="{ the_tag: subjectValue === theSubject }"
  @click="searchSubject(subjectValue)"
>
  {{ subjectValue }}
</span>

</template>

<script>
export default {
	name: "SingleSubject",
	props: {
		subject: {
			type: Object,
			required: true
		}/* ,
		row: {
			type: Number,
			required: false
		} */
	},
	computed: {
		subjectValue() {
			return this.subject.value || this.subject['@value']
		},
		theSubject() {
			return this.$store.getters['getQueryTitle']
		},
		formatIsGrid() {
			return this.$store.getters['getFormat'] === 'grid'
		}
	},
	methods: {
		searchSubject(subject) {
			this.$store.commit('updateQueryTitle', subject)
			this.$store.commit('updateQuerySubject', '')
			this.$store.dispatch('searchByKeyWord', subject)
		}
	}
}
</script>

<style lang="scss" scoped>
.single-tag {
	width: auto;
	margin: auto 4px;
	cursor: pointer;
}

.single-tag:hover {
	text-decoration: underline;
	text-shadow: 0px 1px #c7c7c7;
}

.french {
	cursor: pointer;
}
</style>
